var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPrivateLivingroom = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "1em",
  height: "1em",
  viewBox: "0 0 40 40"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h40v40H0z"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "m29.337 20.778-1.104-1.954s-1.175-1.231-.58-2.545c.598-1.315 1.889-1.366 1.889-1.366l3.297 2.343M10.694 25.063H29.34M10.441 14.913v-3.138a1.12 1.12 0 0 1 1.11-1.129h7.227l1.223.323v10.77h-8.45c-.343 0-.648-.157-.85-.404"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "m19.999 10.969 1.212-.322h7.24c.613 0 1.108.506 1.108 1.128v3.137M29.328 21.308a1.1 1.1 0 0 1-.877.436h-8.452M11.768 18.824s1.175-1.23.579-2.546c-.596-1.314-1.888-1.366-1.888-1.366L7.7 16.874M20.067 18.824h-8.3L10.7 20.686"
}), /*#__PURE__*/React.createElement("path", {
  stroke: "#464646",
  d: "M10.673 18.774a2.09 2.09 0 0 0-2.087-2.096A2.09 2.09 0 0 0 6.5 18.774c0 .902.567 1.668 1.362 1.964v5.17c0 .79 2.811.79 2.811 0v-6.982c0-.018-.004-.034-.004-.052q.003-.05.004-.1ZM19.933 18.824h8.3M29.327 18.774c0-1.158.936-2.096 2.087-2.096a2.09 2.09 0 0 1 2.086 2.096c0 .902-.567 1.668-1.362 1.964v5.17c0 .79-2.812.79-2.812 0v-6.982c0-.018.005-.034.005-.052q-.002-.05-.004-.1Z"
}))));
export default SvgPrivateLivingroom;